function toTimezoneOption(tz: string) {
  return { value: tz, label: tz.replace(/_/g, " ") };
}

function buildTimezoneOptions() {
  try {
    return ["UTC", ...(Intl as any).supportedValuesOf("timeZone")].map(
      toTimezoneOption,
    );
  } catch {
    // Fallback for older browsers
    return [
      "UTC",
      "America/New_York",
      "America/Chicago",
      "America/Denver",
      "America/Los_Angeles",
      "Europe/London",
      "Europe/Berlin",
      "Europe/Paris",
      "Asia/Tokyo",
      "Asia/Shanghai",
      "Asia/Kolkata",
      "Australia/Sydney",
    ].map(toTimezoneOption);
  }
}

export const timezoneOptions = buildTimezoneOptions();
